
import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import BookingHeader from '@/components/booking/BookingHeader';
import BookingForm from '@/components/booking/BookingForm';
import WhatToExpect from '@/components/booking/WhatToExpect';

const Book: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const serviceParam = queryParams.get('service');
  const planParam = queryParams.get('plan');
  
  // Check if this is for residential services
  const isResidential = serviceParam === 'residential';
  
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <BookingHeader />
      
      <section className="section-padding bg-white">
        <div className="container-wide max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-8 border border-gray-100 mb-12">
            <h2 className="heading-lg text-itmgmt-dark-blue mb-6 text-center">
              Schedule Your Free Consultation
            </h2>
            <p className="text-gray-600 mb-8 text-center max-w-2xl mx-auto">
              Fill out the form below and our team will reach out to you shortly to confirm your consultation.
            </p>
            <BookingForm 
              serviceParam={serviceParam} 
              planParam={planParam} 
              isResidential={isResidential}
            />
          </div>
          
          <WhatToExpect />
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Book;
